<template>
  <div class="pt-5">
    <CommonExpansionPanel :currentPanel="currentPanel" :readonly="readonly">
      <template v-slot:title-panel>
        Datos del cliente
      </template>
      <v-expansion-panel-content>
        <v-form ref="firstStepForm" :lazy-validation="true">
          <div v-if="polizaData.clienteId">
            <v-alert type="success" outlined dense>
              Cliente seleccionado :
              {{
                `ID: ${polizaData.clienteId || ""} - ${polizaData.nombres ||
                  ""} ${polizaData.apellidoPaterno || ""}
              ${polizaData.apellidoMaterno || ""}`
              }}
              <template v-slot:append>
                <v-btn icon @click="limpiarCliente" small>
                  <v-icon color="green darken-2">mdi-close</v-icon>
                </v-btn>
              </template>
            </v-alert>
          </div>
          <!-- <v-row v-else>
            <v-col cols="12" md="4">
              <v-label>Buscar cliente ya existente?</v-label>
              <v-radio-group v-model="searchOrCreate" row>
                <v-radio
                  label="Si, buscarlo"
                  value="true"
                  color="primary"
                ></v-radio>
                <v-radio
                  label="No, levantar datos"
                  value="false"
                  color="primary"
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row> -->
          <div v-show="searchOrCreate == 'true' && !polizaData.clienteId">
            <SearchClientForm
              :searchForRFC="searchForRFC"
              :finalFilters="finalFilters"
              @restarRFCflag="searchForRFC = false"
              @beforeStep="beforeStep"
              @postClienteSelecciondo="postClienteSelecciondo"
            />
          </div>
          <div v-if="searchOrCreate != 'true' && polizaData.clienteId == null">
            <v-row>
              <v-col cols="3">
                <v-autocomplete
                  label="Tipo de Persona (Régimen)"
                  outlined
                  v-model="polizaData.regimen_persona"
                  color="#00a7e4"
                  type="text"
                  :items="regimentList"
                  :rules="requiredRule"
                ></v-autocomplete>
              </v-col>
              <v-col cols="9" style="text-align: end;" v-show="hidden">
                <v-badge bordered color="error" overlap :content="total">
                  <v-fab-transition>
                    <v-btn
                      v-show="hidden"
                      color="info"
                      fab
                      large
                      dark
                      @click="searchForRFC = true"
                    >
                      <v-icon>mdi-account-alert</v-icon>
                    </v-btn>
                  </v-fab-transition>
                </v-badge>
              </v-col>
            </v-row>
            <v-row>
              <v-col m="2" v-if="polizaData.regimen_persona == 'Moral'">
                <v-text-field
                  label="Razón Social"
                  outlined
                  v-model="polizaData.razon_social"
                  color="#00a7e4"
                  type="text"
                  :rules="requiredRule"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row v-if="polizaData.regimen_persona != null">
              <v-col m="12" md="6" lg="3" xl="3">
                <v-text-field
                  v-model="polizaData.nombres"
                  label="Nombre(s)"
                  placeholder="Requerido"
                  color="#00a7e4"
                  type="text"
                  outlined
                  clearable
                  :rules="requiredRuleCaracteres"
                ></v-text-field>
              </v-col>
              <v-col m="12" md="6" lg="3" xl="3">
                <v-text-field
                  v-model="polizaData.apellidoPaterno"
                  label="Apellido Paterno"
                  placeholder="Requerido"
                  color="#00a7e4"
                  type="text"
                  outlined
                  clearable
                  :rules="requiredRuleCaracteres"
                ></v-text-field>
              </v-col>
              <v-col m="12" md="6" lg="3" xl="3">
                <v-text-field
                  v-model="polizaData.apellidoMaterno"
                  label="Apellido Materno"
                  placeholder="Requerido"
                  color="#00a7e4"
                  type="text"
                  outlined
                  clearable
                  :rules="requiredRuleCaracteres"
                ></v-text-field>
              </v-col>
              <v-col m="12" md="6" lg="3" xl="3">
                <v-text-field
                  label="Teléfono"
                  outlined
                  color="#00a7e4"
                  v-mask="'##########'"
                  v-model="polizaData.celular"
                  clearable
                  :rules="[celularRule]"
                ></v-text-field>
              </v-col>
              <v-col m="12" md="6" lg="3" xl="3">
                <CommonEmailAutocomplete
                  @emailUpdate="(e) => (polizaData.correoElectronico = e)"
                ></CommonEmailAutocomplete>
              </v-col>
              <v-col m="12" md="6" lg="3" xl="3">
                <v-text-field
                  v-model="polizaData.fechaNacimiento"
                  label="Fecha de Nacimiento"
                  outlined
                  type="date"
                  color="#00a7e4"
                  :rules="requiredRuleDate"
                  clearable
                ></v-text-field>
              </v-col>
              <v-col m="12" md="6" lg="3" xl="3">
                <v-text-field
                  v-model="polizaData.edad"
                  type="text"
                  label="Edad"
                  outlined
                  color="#00a7e4"
                  :rules="requiredRule"
                ></v-text-field>
              </v-col>
              <v-col
                m="12"
                md="6"
                lg="3"
                xl="3"
                v-if="polizaData.regimen_persona != null"
              >
                <v-text-field
                  v-model="polizaData.rfc"
                  label="RFC"
                  placeholder="Requerido"
                  color="#00a7e4"
                  type="text"
                  outlined
                  :rules="rfcRules"
                  @input="onInputToUpper"
                ></v-text-field>
              </v-col>
              <v-col m="12" md="6" lg="3" xl="3">
                <v-autocomplete
                  label="Género"
                  outlined
                  color="#00a7e4"
                  v-model="polizaData.genero"
                  :items="generoList"
                  :rules="requiredRule"
                ></v-autocomplete>
              </v-col>
              <v-col m="12" md="6" lg="3" xl="3">
                <v-autocomplete
                  label="Estado civil"
                  outlined
                  color="#00a7e4"
                  v-model="polizaData.estadoCivilSelected"
                  :items="['Soltero(a)', 'Casado(a)']"
                  :rules="requiredRule"
                ></v-autocomplete>
              </v-col>
            </v-row>
            <v-row v-if="polizaData.regimen_persona != null">
              <v-col m="12" md="6" lg="3" xl="3">
                <v-text-field
                  v-model="polizaData.codigoPostal"
                  label="Código Postal"
                  placeholder="Requerido"
                  color="#00a7e4"
                  type="text"
                  outlined
                  :rules="requiredRule"
                ></v-text-field>
              </v-col>
              <v-col
                m="12"
                md="6"
                lg="3"
                xl="3"
                v-if="polizaData.codigoPostal != null"
              >
                <v-text-field
                  v-model="polizaData.calle"
                  label="Calle"
                  placeholder="Requerido"
                  color="#00a7e4"
                  type="text"
                  outlined
                  :rules="requiredRule"
                ></v-text-field>
              </v-col>
              <v-col
                m="12"
                md="6"
                lg="3"
                xl="3"
                v-if="polizaData.codigoPostal != null"
              >
                <v-text-field
                  v-model="polizaData.numExterior"
                  label="Numero Exterior"
                  placeholder="Requerido"
                  color="#00a7e4"
                  type="text"
                  outlined
                  :rules="requiredRule"
                ></v-text-field>
              </v-col>
              <v-col
                m="12"
                md="6"
                lg="3"
                xl="3"
                v-if="polizaData.codigoPostal != null"
              >
                <v-text-field
                  v-model="polizaData.numInterior"
                  label="Numero interior"
                  placeholder="Requerido"
                  color="#00a7e4"
                  type="text"
                  outlined
                  :rules="requiredRule"
                ></v-text-field>
              </v-col>
              <v-col
                m="12"
                md="6"
                lg="3"
                xl="3"
                v-if="polizaData.codigoPostal != null"
              >
                <v-autocomplete
                  label="Colonia"
                  v-model="polizaData.colonia"
                  :items="colonias"
                  item-text="nombreColonia"
                  item-value="nombreColonia"
                  placeholder="Requerido"
                  color="#00a7e4"
                  type="text"
                  outlined
                  :rules="requiredRule"
                ></v-autocomplete>
              </v-col>
              <v-col
                m="12"
                md="6"
                lg="3"
                xl="3"
                v-if="polizaData.codigoPostal != null"
              >
                <v-text-field
                  label="Ciudad"
                  v-model="polizaData.municipio"
                  placeholder="Requerido"
                  color="#00a7e4"
                  type="text"
                  outlined
                  :rules="requiredRule"
                ></v-text-field>
              </v-col>
              <v-col
                m="12"
                md="6"
                lg="3"
                xl="3"
                v-if="polizaData.codigoPostal != null"
              >
                <v-autocomplete
                  label="Estado de la República"
                  v-model="polizaData.estadoRepublicaSelected"
                  placeholder="Requerido"
                  :items="estados"
                  item-text="name"
                  item-value="name"
                  color="#00a7e4"
                  type="text"
                  outlined
                  :rules="requiredRule"
                ></v-autocomplete>
              </v-col>
            </v-row>
          </div>
          <v-row
            v-if="
              searchOrCreate != 'true' ||
                (searchOrCreate != 'false' && polizaData.clienteId != null)
            "
          >
            <v-col
              cols="12"
              sm="12"
              md="12"
              lg="12"
              xl="12"
              style="text-align: end;"
            >
              <v-btn
                rounded
                dark
                outlined
                color="#00a7e4"
                @click="beforeStep"
                style="margin-right: 11px;"
              >
                <span>
                  Anterior
                </span>
              </v-btn>
              <v-btn
                rounded
                dark
                class="common-botton"
                @click="validateStep"
                :disabled="disabledForClienteID"
              >
                <span>
                  Siguiente
                </span>
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-expansion-panel-content>
    </CommonExpansionPanel>
  </div>
</template>

<script>
import CommonExpansionPanel from "@/components/commonComponents/CommonExpansionPanel.vue";
import { mainAxios } from "@/mainAxios.js";
import moment from "moment";
import RfcFacil from "rfc-facil";
import CommonEmailAutocomplete from "@/components/commonComponents/CommonEmailAutocomplete.vue";
import SearchClientForm from "./SearchClientForm.vue";
import { getClienteByFiltersAreaNegocio } from "@/services/cliente/Clientes";
import debounce from "lodash/debounce";

export default {
  components: {
    CommonExpansionPanel,
    CommonEmailAutocomplete,
    SearchClientForm,
  },
  props: {
    currentStep: Number,
  },
  data() {
    return {
      polizaData: {
        regimen_persona: "Física",
        razon_social: null,
        rfc: "",
        nombres: null,
        apellidoPaterno: null,
        apellidoMaterno: null,
        celular: null,
        fecha_nacimiento: null,
        edad: null,
        codigoPostal: null,
        correoElectronico: null,
      },
      rol: JSON.parse(localStorage.getItem("roles"))[0].rol,
      regimentList: ["Física", "Moral"],
      rfcRules: [
        (v) => !!v || "RFC es requerido",
        (v) =>
          !v ||
          [10, 12, 13].includes(v.length) ||
          "RFC debe tener 10, 12 o 13 caracteres",
        (v) =>
          !v ||
          /^[A-Za-z\d]{10,13}$/.test(v) ||
          "RFC no es válido, usa solo letras y dígitos",
      ],
      requiredRule: [(v) => !!v || "El campo es requerido"],
      generoList: ["Masculino", "Femenino"],
      emailRules: [
        (v) => !!v || "E-mail es requerido",
        (v) => /.+@.+\..+/.test(v) || "E-mail debe de ser valido",
      ],
      colonias: [],
      estados: [
        { id: 1, name: "Aguascalientes" },
        { id: 2, name: "Baja California" },
        { id: 3, name: "Baja California Sur" },
        { id: 4, name: "Campeche" },
        { id: 5, name: "Coahuila de Zaragoza" },
        { id: 6, name: "Colima" },
        { id: 7, name: "Chiapas" },
        { id: 8, name: "Chihuahua" },
        { id: 9, name: "Ciudad de México" },
        { id: 10, name: "Durango" },
        { id: 11, name: "Guanajuato" },
        { id: 12, name: "Guerrero" },
        { id: 13, name: "Hidalgo" },
        { id: 14, name: "Jalisco" },
        { id: 15, name: "Estado de México" },
        { id: 16, name: "Michoacán de Ocampo" },
        { id: 17, name: "Morelos" },
        { id: 18, name: "Nayarit" },
        { id: 19, name: "Nuevo León" },
        { id: 20, name: "Oaxaca" },
        { id: 21, name: "Puebla" },
        { id: 22, name: "Querétaro" },
        { id: 23, name: "Quintana Roo" },
        { id: 24, name: "San Luis Potosí" },
        { id: 25, name: "Sinaloa" },
        { id: 26, name: "Sonora" },
        { id: 27, name: "Tabasco" },
        { id: 28, name: "Tamaulipas" },
        { id: 29, name: "Tlaxcala" },
        { id: 30, name: "Veracruz de Ignacio de la Llave" },
        { id: 31, name: "Yucatán" },
        { id: 32, name: "Zacatecas" },
      ],
      currentPanel: null,
      readonly: true,
      requiredRuleCaracteres: [
        (v) => !!v || "Este campo es requerido", // Verifica que el campo no esté vacío
        (v) => (v && v.length >= 3) || "Mínimo 3 caracteres", // Mínimo de 3 caracteres
        (v) =>
          /^[a-zA-Z\s]+$/.test(v) || "No se permiten caracteres especiales", // Solo letras y espacios
      ],
      requiredRuleDate: [
        (v) => !!v || "La fecha es requerida.",
        (v) =>
          this.isPastDate(v) ||
          "La fecha no puede ser hoy ni una en el futuro.",
        (v) =>
          this.isWithinLast100Years(v) ||
          "La fecha no puede ser mayor a 100 años.",
      ],
      celularRule: (value) => {
        // 1) requerido
        if (!value) {
          return "El teléfono es requerido";
        }
        // 2) longitud exacta
        const formato = /^\d{10}$/;
        if (!formato.test(value)) {
          return "El teléfono debe tener 10 dígitos";
        }
        // 3) no todos iguales
        const soloRepetidos = /^(\d)\1{9}$/;
        if (soloRepetidos.test(value)) {
          return "Teléfono no válido (número repetitivo)";
        }
        // 4) pasa todas las reglas
        return true;
      },
      searchOrCreate: "false",
      usuarios: [],
      isLoading: false,
      search: null,
      customer_id: null,
      filters: {
        nombre: null,
        apellido_paterno: null,
        apellido_materno: null,
        correo: null,
        telefono: null,
        clienteId: null,
      },
      total: 0,
      hidden: false,
      searchForRFC: false,
      finalFilters: {},
    };
  },

  watch: {
    "polizaData.fechaNacimiento"(val) {
      var today = moment().format("YYYY-MM-DD");
      var birthday = moment(val, "YYYY-MM-DD");
      this.polizaData.edad = moment(today, "YYYY-MM-DD").diff(
        moment(birthday, "YYYY-MM-DD"),
        "years"
      );
      this.actualizarRfc();
    },
    "polizaData.codigoPostal"(val) {
      if (typeof val != "undefined") {
        if (val.length == 5) {
          const config = {
            headers: {
              Authorization: "Bearer " + localStorage.agenteAccessToken,
            },
          };
          mainAxios
            .get("/v1/catalogo/direccion?cp=" + val, config)
            .then((response) => {
              if (response.data.listaColonias.length >= 1) {
                this.colonias = response.data.listaColonias;
                this.polizaData.estadoRepublicaSelected = this.estados.find(
                  (e) => e.id == response.data.nEstado
                ).name;
                this.polizaData.municipio = response.data.nombreMunicipio;
              } else if (response.error == "") {
                alert("No existe ese codigo postal");
              }
            });
        }
      }
    },
    polizaData: {
      handler(val) {
        const {
          nombres,
          apellidoPaterno,
          apellidoMaterno,
          celular,
          correoElectronico,
        } = val;
        this.debouncedActualizarRfc();
        if (
          (nombres && nombres.length >= 3) ||
          (apellidoPaterno && apellidoPaterno.length >= 3) ||
          (apellidoMaterno && apellidoMaterno.length >= 3) ||
          (celular && celular.length == 10) ||
          (correoElectronico && correoElectronico.length > 3)
        ) {
          this.debouncedGetCliente();
        }
      },
      deep: true,
    },
    "polizaData.rfc"(val) {
      this.hidden = false;
      this.total = 0;
      if (
        (val && val.length === 10) ||
        val.length === 12 ||
        val.length === 13
      ) {
        this.getClienteByFiltersAreaNegocio();
      }
    },
    currentStep(val) {
      if (val == 2) {
        this.currentPanel = 0;
        this.readonly = false;
      } else {
        this.currentPanel = 1;
        this.readonly = true;
      }
    },
  },
  methods: {
    validateStep() {
      if (this.$refs.firstStepForm.validate()) {
        (this.polizaData.nombre_cliente = `${this.polizaData.nombre}
        ${this.polizaData.apellido_paterno}
        ${this.polizaData.apellido_materno}`),
          this.$emit("ChangeOnlyStep", 3, this.polizaData);
      }
    },
    beforeStep() {
      this.$emit("ChangeOnlyStep", 1, null);
    },
    actualizarRfc() {
      if (
        !this.polizaData.nombres ||
        !this.polizaData.apellidoPaterno ||
        !this.polizaData.apellidoMaterno ||
        !this.polizaData.fechaNacimiento
      )
        return;
      const arregloNacimiento = moment(this.polizaData.fechaNacimiento)
        .format("DD/MM/YYYY")
        .split("/")
        .map((e) => Number(e));
      if (arregloNacimiento.length < 3) return;
      const rfc = RfcFacil.forNaturalPerson({
        name: this.polizaData.nombres,
        firstLastName: this.polizaData.apellidoPaterno,
        secondLastName: this.polizaData.apellidoMaterno,
        day: arregloNacimiento[0],
        month: arregloNacimiento[1],
        year: arregloNacimiento[2],
      });
      this.polizaData.rfc = rfc;
    },
    onInputToUpper() {
      this.polizaData.rfc = this.polizaData.rfc.toUpperCase();
    },
    isPastDate(value) {
      const selectedDate = new Date(value);
      const today = new Date();
      today.setHours(0, 0, 0, 0); // Ignorar el tiempo para la comparación
      return selectedDate < today;
    },
    isWithinLast100Years(value) {
      const selectedDate = new Date(value);
      const date100YearsAgo = new Date();
      date100YearsAgo.setFullYear(date100YearsAgo.getFullYear() - 100);
      return selectedDate >= date100YearsAgo;
    },
    postClienteSelecciondo(e) {
      this.$toast.success("Cliente seleccionado con exito!");
      let cliente = e[0];
      this.polizaData = {
        regimen_persona: "Física",
        razon_social: cliente.razonSocial ?? null,
        rfc: cliente.rfc ?? null,
        nombres: cliente.nombre ?? null,
        fechaNacimiento: cliente.fechaNacimiento ?? null,
        edad: this.calcularEdad(cliente.fechaNacimiento) ?? null,
        apellidoPaterno: cliente.apellidoPaterno ?? null,
        apellidoMaterno: cliente.apellidoMaterno ?? null,
        genero: cliente.genero == "M" ? "Masculino" : "Femenino",
        estadoCivilSelected: cliente.estadoCivil ?? null,
        celular: cliente.telefonoMovil ? cliente.telefonoOficina : null,
        clienteId: cliente.id,
        correoElectronico: cliente.correo ?? null,
      };
    },
    calcularEdad(fechaNacimiento) {
      if (!fechaNacimiento) return null;
      return moment().diff(moment(fechaNacimiento, "YYYY-MM-DD"), "years");
    },
    limpiarCliente() {
      this.polizaData = {
        regimen_persona: "Física",
        razon_social: null,
        rfc: null,
        nombres: null,
        fechaNacimiento: null,
        edad: null,
        apellidoPaterno: null,
        apellidoMaterno: null,
        genero: null,
        estadoCivilSelected: null,
        celular: null,
        clienteId: null,
      };
      this.filters = {
        nombre: null,
        apellido_paterno: null,
        apellido_materno: null,
        correo: null,
        telefono: null,
        clienteId: null,
      };
    },
    async getClienteByFiltersAreaNegocio() {
      try {
        this.searchForRFC = false;
        this.total = 0;
        this.hidden = false;
        const finalFilters = {
          ...(this.polizaData.nombres != null &&
          this.polizaData.nombres.length >= 4
            ? { nombre: this.polizaData.nombres.trim() }
            : {}),
          ...(this.polizaData.apellidoPaterno != null &&
          this.polizaData.apellidoPaterno.length >= 4
            ? { apellido_paterno: this.polizaData.apellidoPaterno.trim() }
            : {}),
          ...(this.polizaData.apellidoMaterno != null &&
          this.polizaData.apellidoMaterno.length >= 4
            ? { apellido_materno: this.polizaData.apellidoMaterno.trim() }
            : {}),
          ...(this.polizaData.celular != null &&
          this.polizaData.celular.length >= 4
            ? { telefono: this.polizaData.celular.trim() }
            : {}),
          ...(this.polizaData.correoElectronico != null &&
          this.polizaData.correoElectronico.length >= 4
            ? { correo: this.polizaData.correoElectronico.trim() }
            : {}),
          ...(this.polizaData.rfc != null &&
          (this.polizaData.rfc.length === 10 ||
            this.polizaData.rfc.length === 12 ||
            this.polizaData.rfc.length === 13)
            ? { rfc: this.polizaData.rfc.trim() }
            : {}),
        };
        this.finalFilters = finalFilters;
        const size = 10;
        const page = 0;

        let response = await getClienteByFiltersAreaNegocio(
          finalFilters,
          size,
          page
        );
        if (response.total > 0) {
          this.total = response.total;
          this.hidden = true;
        }
        this.loading = false;
      } catch (e) {
        console.error(e);
        this.$toast.error("A ocurrido un error en encontrar cliente", e);
      }
    },
  },
  created() {
    // Creamos las versiones debounced de los métodos
    this.debouncedActualizarRfc = debounce(this.actualizarRfc, 1000);
    this.debouncedGetCliente = debounce(
      this.getClienteByFiltersAreaNegocio,
      1000
    );
  },
  computed: {
    disabledForClienteID() {
      return this.total > 0 && this.polizaData.clienteId == null;
    },
  },
};
</script>
